module.exports = "https://img.xiyuyouxi.com/saas/img/icon2.9afc6962.png";